export default __webpack_public_path__ + "static/media/Research-page-header-mobile.473516fb.png";